import global_es from './es/global.json'
import global_br from './pt/global.json'

let initLanguage = null


if (window.location.hostname === "plataforma.ruedata.com" || window.location.hostname === "testing.ruedata.com" || window.location.hostname === "localhost") {
    localStorage.setItem("LanguageSelected", "es")
    initLanguage = "es"
} else {
    localStorage.setItem("LanguageSelected", "pt")
    initLanguage = "pt"
}



// if (initLanguage === null) {
//     localStorage.setItem("LanguageSelected", "es")
//     initLanguage = "es"
// ? 
// localStorage.getItem("LanguageSelected") : 
// localStorage.getItem("LanguageSelected") === "es" ?
// localStorage.getItem("LanguageSelected") :
// localStorage.getItem("LanguageSelected") === null ? null : null
// }



// if (initLanguage === null) {
//     localStorage.setItem("LanguageSelected", "es")
//     initLanguage = "es"
// }


export const initTranslation = {
    interpolation: { escapeValue: false },
    lng: initLanguage,
    resources: {
        es: {
            global: global_es,
        },
        pt: {
            global: global_br,
        }
    }
}